module.exports = __webpack_public_path__ + "img/icons_non-dir.3954333e.svg";